import React, { Component } from 'react';
import { Button, FormGroup } from 'reactstrap';
import autobind from 'autobind-decorator';
import { connect } from 'react-redux';
import * as locations from 'customers/actions/locations';
import { DetailContainer } from 'customers/DetailContainer';
import { Formik, Form, Field } from 'formik';
import { CustomField } from 'apa/components/CustomField';  
import * as yup from 'yup';
import Loading from 'apa/components/Loading';
import { BaseUrl } from '../../BaseUrl/BaseUrl'; 

// Validation schema for location form
const LocationScheme = yup.object().shape({
    name: yup.string().required('Name is required'),
    zip_code: yup.string().required('ZIP code is required'),
    street: yup.string().required('Street is required'),
});

@connect(
    state => ({
        auth: state.apa
    }),
    dispatch => ({
        add: (location, history) => dispatch(locations.add(location, history)),
        update: (location, history) => dispatch(locations.update(location, history)),
        fetchLocation: (locationId) => dispatch(locations.fetchLocation(locationId))
    })
)
export default class LocationDetails extends Component {
    constructor(props) {
        super(props);
        const locationId = props.match.params.location_id;
        if (locationId) {
            this.state = {
                isNew: false,
                isLoading: true,
                location: null,
                customer: null
            }
        } else {
            const customer_id = props.match.params.customer_id;
            this.state = {
                isNew: true,
                isLoading: false,
                customer: customer_id,
                location: {
                    name: '',
                    zip_code: '',
                    street: ''
                }
            };
        }
        this._isMounted = false;
    }

    componentDidMount() {
        this._isMounted = true;
        const headers = { 'Content-Type': 'application/json' };
        headers['Authorization'] = `Token ${this.props.auth.token}`;

        if (!this.state.isNew) {
            const id = this.props.match.params.location_id;
            fetch(
                `${BaseUrl}/api/customers/locations/${id}/`,
                { headers }
            )
                .then(res => {
                    if (!res.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return res.json();
                })
                .then(location => {
                    if (this._isMounted) {
                        this.setState({ location: location });
                        return fetch(
                            `${BaseUrl}/api/customers/${location.customer}/?year=2019`,
                            { headers }
                        );
                    }
                })
                .then(res => {
                    if (!res.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return res.json();
                })
                .then(customer => {
                    if (this._isMounted) {
                        this.setState({ isLoading: false, customer: customer });
                    }
                })
                .catch(error => {
                    console.error('Error fetching location or customer:', error);
                    if (this._isMounted) {
                        this.setState({ isLoading: false });
                    }
                });
        } else {
            fetch(
                `${BaseUrl}/api/customers/${this.state.customer}/?year=2019`,
                { headers }
            )
                .then(res => res.json())
                .then(customer => {
                    if (this._isMounted) {
                        this.setState({ customer: customer });
                    }
                });
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    @autobind
    onSubmit(values, { setSubmitting }) {
        const { history } = this.props;
        const customer_id = this.props.match.params.customer_id || this.state.customer.id;

        if (this.state.isNew) {
            this.props.add(
                { ...values, customer: this.state.customer.id },
                history
            ).then(() => {
                history.push(`/customer/${customer_id}/locations`);
            }).catch(error => {
                console.error('Error adding location:', error);
                setSubmitting(false);
            });
        } else {
            this.props.update(
                { ...values, id: this.props.match.params.location_id },
                history
            ).then(() => {
                history.push(`/customer/${customer_id}/locations`);
            }).catch(error => {
                console.error('Error updating location:', error);
                setSubmitting(false);
            });
        }
    }

    render() {
        if (this.state.isLoading) {
            return <Loading />;
        }

        const customer_id = this.props.match.params.customer_id || this.state.customer.id;
        return (
            <DetailContainer id={customer_id}>
                <h1>{this.state.customer.name}</h1>
                <Formik
                    initialValues={this.state.location}
                    validationSchema={LocationScheme}
                    onSubmit={this.onSubmit}
                >
                    {({ isSubmitting }) => (
                        <Form className='form'>
                            <FormGroup>
                                <Field component={CustomField} type="text" name="name" label="Name" />
                            </FormGroup>
                            <FormGroup> 
                                <Field component={CustomField} type="text" name="zip_code" label="PLZ" />
                            </FormGroup>
                            <FormGroup>
                                <Field component={CustomField} type="text" name="street" label="Straße" />
                            </FormGroup>
                            <FormGroup>
                                <Button color="primary" type="submit" disabled={isSubmitting}>
                                    Speichern
                                </Button>
                            </FormGroup>
                        </Form>
                    )}
                </Formik>
            </DetailContainer>
        );
    }
}